require('./currencies-form.scss')

module.exports = {
  template: require('./currencies-form.pug')()
  controller: require('./currencies-form.ctrl')
  bindings:
    currency: '<'
    onSubmit: '&'
}
